import { fmt } from '../util/math.js';

const saveKey = 'looper-day-leaderboard-v1';
const $ = (id) => document.getElementById(id);

let elements = null;

export function initLeaderboard() {
  elements = {
    modal: $('leaderboardModal'),
    list: $('leaderList'),
    bestScorePreview: $('bestScorePreview'),
    bestWavePreview: $('bestWavePreview'),
    runsPreview: $('runsPreview'),
    openButton: $('leaderboardBtn'),
    clearButton: $('clearLeaderboard'),
    seedButton: $('seedLeaderboard'),
  };
  elements.openButton?.addEventListener('click', () => {
    renderLeaderboard();
    elements.modal?.classList.remove('hidden');
  });
  elements.clearButton?.addEventListener('click', () => {
    writeScores([]);
    renderLeaderboard();
  });
  elements.seedButton?.addEventListener('click', () => {
    writeScores([
      { name: 'Runner', score: 18420, wave: 9, kills: 312, at: Date.now() - 86400000 },
      { name: 'Ghost', score: 12680, wave: 7, kills: 221, at: Date.now() - 172800000 },
      { name: 'Pulse', score: 9040, wave: 5, kills: 166, at: Date.now() - 259200000 },
    ]);
    renderLeaderboard();
  });
  updateScorePreview();
  return elements;
}

export function readScores() {
  try {
    return JSON.parse(localStorage.getItem(saveKey) || '[]');
  } catch {
    return [];
  }
}

export function writeScores(scores) {
  localStorage.setItem(saveKey, JSON.stringify(scores.slice(0, 20)));
  updateScorePreview();
}

export function addScore(entry) {
  const scores = readScores();
  scores.push({ ...entry, at: Date.now() });
  scores.sort((a, b) => b.score - a.score || b.wave - a.wave || b.kills - a.kills);
  writeScores(scores);
}

export function renderLeaderboard() {
  if (!elements) initLeaderboard();
  const list = elements.list;
  if (!list) return;

  const scores = readScores().slice(0, 10);
  list.innerHTML = '';
  if (!scores.length) {
    const empty = document.createElement('li');
    empty.innerHTML = '<b>-</b><span>No local scores yet</span><strong>Start a run</strong>';
    list.appendChild(empty);
    return;
  }

  scores.forEach((score, index) => {
    const date = new Date(score.at || Date.now()).toLocaleDateString();
    const item = document.createElement('li');
    item.innerHTML = `<b>#${index + 1}</b><span><strong>${escapeHtml(score.name || 'Runner')}</strong><br><small class="tiny">Wave ${score.wave} - ${score.kills} kills - ${date}</small></span><strong>${fmt(score.score)}</strong>`;
    list.appendChild(item);
  });
}

export function updateScorePreview() {
  if (!elements) return;
  const scores = readScores();
  const best = scores[0];
  if (elements.bestScorePreview) elements.bestScorePreview.textContent = best ? fmt(best.score) : '0';
  if (elements.bestWavePreview) elements.bestWavePreview.textContent = best ? String(best.wave) : '0';
  if (elements.runsPreview) elements.runsPreview.textContent = scores.length.toString();
}

function escapeHtml(str) {
  return String(str).replace(/[&<>'"]/g, (char) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    "'": '&#39;',
    '"': '&quot;',
  }[char]));
}
